export function Kicker({ children, className = '' }) {
  return (
    <span className={`mono-label text-brand ${className}`}>{children}</span>
  );
}

export function SectionHeading({ kicker, title, className = '', light = false }) {
  return (
    <div className={className}>
      {kicker && <Kicker className={light ? 'text-white/60' : ''}>{kicker}</Kicker>}
      <h2
        className={`mt-4 font-display text-3xl font-semibold tracking-tighter sm:text-4xl ${
          light ? 'text-white' : 'text-navy'
        }`}
      >
        {title}
      </h2>
    </div>
  );
}
